// salary-calculator.js
(function() {
  const currentScript = document.currentScript;

  // 1️⃣ Create container
  const container = document.createElement("div");
  container.className = "salary-calc-container";
  container.style.maxWidth = "700px";
  container.style.margin = "40px auto";
  container.style.padding = "30px";
  container.style.border = "1px solid #ddd";
  container.style.borderRadius = "12px";
  container.style.fontFamily = "Arial, sans-serif";
  container.style.background = "#fff";
  container.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";

  // 2️⃣ Inner HTML
  container.innerHTML = `
    <h2 style="margin-bottom:25px;color:#0b5a82;text-align:center;">Salary Calculator</h2>

    <div style="display:grid; grid-template-columns:1fr 1fr; gap:20px; margin-bottom:20px;">
      <div>
        <label>Salary amount ($):</label>
        <input type="number" class="salary-amount" value="50" min="0" step="1" style="width:100%;padding:6px;border-radius:4px;border:1px solid #ccc;">
        <div style="text-align:center;">$<span class="salary-value">50</span> / <span class="pay-frequency-value">Hour</span></div>
      </div>
      <div>
        <label>Pay frequency:</label>
        <select class="pay-frequency" style="width:100%;padding:6px;border-radius:4px;border:1px solid #ccc;">
          <option value="Hour">Hour</option>
          <option value="Day">Day</option>
          <option value="Week">Week</option>
          <option value="Month">Month</option>
          <option value="Quarter">Quarter</option>
          <option value="Year">Year</option>
        </select>
      </div>

      <div>
        <label>Hours per week:</label>
        <input type="range" class="hours-week" min="0" max="80" value="40" step="1" style="width:100%;">
        <div style="text-align:center;"><span class="hours-week-value">40</span> hrs/week</div>
      </div>

      <div>
        <label>Days per week:</label>
        <input type="range" class="days-week" min="0" max="7" value="5" step="1" style="width:100%;">
        <div style="text-align:center;"><span class="days-week-value">5</span> days/week</div>
      </div>

      <div>
        <label>Holidays per year:</label>
        <input type="range" class="holidays-year" min="0" max="30" value="10" step="1" style="width:100%;">
        <div style="text-align:center;"><span class="holidays-year-value">10</span> days</div>
      </div>

      <div>
        <label>Vacation days per year:</label>
        <input type="range" class="vacation-year" min="0" max="30" value="15" step="1" style="width:100%;">
        <div style="text-align:center;"><span class="vacation-year-value">15</span> days</div>
      </div>
    </div>

    <h3 style="margin-top:30px;text-align:center;">Results</h3>
    <table class="results-table" style="width:100%;border-collapse:collapse;text-align:center;">
      <thead>
        <tr style="background:#0b5a82;color:#fff;">
          <th style="padding:10px;border:1px solid #ddd;">Frequency</th>
          <th style="padding:10px;border:1px solid #ddd;">Unadjusted</th>
          <th style="padding:10px;border:1px solid #ddd;">Holidays & Vacation Adjusted</th>
        </tr>
      </thead>
      <tbody class="results-body"></tbody>
    </table>
  `;

  currentScript.parentNode.insertBefore(container, currentScript);

  // ===== Elements =====
  const salaryInput = container.querySelector(".salary-amount");
  const salaryDisplay = container.querySelector(".salary-value");
  const frequencyInput = container.querySelector(".pay-frequency");
  const frequencyDisplay = container.querySelector(".pay-frequency-value");
  const hoursWeekInput = container.querySelector(".hours-week");
  const hoursWeekDisplay = container.querySelector(".hours-week-value");
  const daysWeekInput = container.querySelector(".days-week");
  const daysWeekDisplay = container.querySelector(".days-week-value");
  const holidaysInput = container.querySelector(".holidays-year");
  const holidaysDisplay = container.querySelector(".holidays-year-value");
  const vacationInput = container.querySelector(".vacation-year");
  const vacationDisplay = container.querySelector(".vacation-year-value");
  const resultsBody = container.querySelector(".results-body");

  // ===== Calculation =====
  function fmt(v) {
    return isFinite(v) ? `$${v.toLocaleString(undefined,{maximumFractionDigits:2})}` : "—";
  }

  function calculateSalary() {
    const salary = parseFloat(salaryInput.value);
    const frequency = frequencyInput.value;
    const hoursPerWeek = parseFloat(hoursWeekInput.value);
    const daysPerWeek = parseFloat(daysWeekInput.value);
    const holidays = parseFloat(holidaysInput.value);
    const vacation = parseFloat(vacationInput.value);

    if(isNaN(salary) || salary <= 0) return;

    salaryDisplay.textContent = salary;
    frequencyDisplay.textContent = frequency;
    hoursWeekDisplay.textContent = hoursPerWeek;
    daysWeekDisplay.textContent = daysPerWeek;
    holidaysDisplay.textContent = holidays;
    vacationDisplay.textContent = vacation;

    // Standardize everything to annual
    let annualUnadjusted = 0;
    switch(frequency) {
      case "Hour": annualUnadjusted = salary * hoursPerWeek * 52; break;
      case "Day": annualUnadjusted = salary * daysPerWeek * 52; break;
      case "Week": annualUnadjusted = salary * 52; break;
      case "Month": annualUnadjusted = salary * 12; break;
      case "Quarter": annualUnadjusted = salary * 4; break;
      case "Year": annualUnadjusted = salary; break;
    }

    const annualAdjusted = annualUnadjusted * (1 - (holidays + vacation) / (daysPerWeek * 52));

    const periods = ["Hour","Day","Week","Month","Quarter","Year"];
    resultsBody.innerHTML = "";
    periods.forEach(p => {
      let unadjusted, adjusted;
      switch(p) {
        case "Hour": unadjusted = annualUnadjusted / (hoursPerWeek*52); adjusted = annualAdjusted / (hoursPerWeek*52); break;
        case "Day": unadjusted = annualUnadjusted / (daysPerWeek*52); adjusted = annualAdjusted / (daysPerWeek*52); break;
        case "Week": unadjusted = annualUnadjusted / 52; adjusted = annualAdjusted / 52; break;
        case "Month": unadjusted = annualUnadjusted / 12; adjusted = annualAdjusted / 12; break;
        case "Quarter": unadjusted = annualUnadjusted / 4; adjusted = annualAdjusted / 4; break;
        case "Year": unadjusted = annualUnadjusted; adjusted = annualAdjusted; break;
      }
      const tr = document.createElement("tr");
      tr.innerHTML = `
        <td style="padding:10px;border:1px solid #ddd;">${p}</td>
        <td style="padding:10px;border:1px solid #ddd;">${fmt(unadjusted)}</td>
        <td style="padding:10px;border:1px solid #ddd;">${fmt(adjusted)}</td>
      `;
      resultsBody.appendChild(tr);
    });
  }

  // ===== Event listeners =====
  [salaryInput, frequencyInput, hoursWeekInput, daysWeekInput, holidaysInput, vacationInput].forEach(el => {
    el.addEventListener("input", calculateSalary);
  });

  calculateSalary();
})();
